import { Resource } from '@redge-media/fo-js-sdk';

const Seasons = Resource.extend({
  endpoint: '/products/vods',
  constructor: function Seasons(opts = {}) {
    Resource.call(this);

    this.collection.comparator = (a, b) => a.number - b.number;
    if (opts.sortType === 'DESC') {
      this.collection.comparator = (a, b) => b.number - a.number;
    }

    this.id = opts.id;
  },

  getPath() {
    return `${this.endpoint}/serials/${this.id}/seasons`;
  },
});

export default Seasons;
